import {AxiosRequestConfig} from 'axios';
import {EntityShiftAllocation} from '../backend/interfaces/entity-shift-allocation';
import {EntityShiftsAllocationsTable} from '../backend/interfaces/entity-shifts-allocations-table';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityShiftsAllocationsRepository {
  private static _instance: EntityShiftsAllocationsRepository;

  private logger: Logger;

  static get instance() {
    if (!this._instance) {
      this._instance = new EntityShiftsAllocationsRepository();
    }

    return this._instance;
  }

  constructor() {
    this.logger = new Logger('ShiftsAllocationsRepository');
  }

  public async getTableFormatEntityShiftsAllocations(
    entityId: string,
    startDate: string,
    endDate: string
  ): Promise<EntityShiftsAllocationsTable> {
    const response = await BackendApiManager.instance.get<EntityShiftsAllocationsTable>(
      `/entities/${entityId}/shifts-allocations?startDate=${startDate}&endDate=${endDate}&tableFormat=true`
    );
    return response.data;
  }

  public async getListFormatEntityShiftsAllocations(
    entityId: string,
    startDate: string,
    endDate: string,
    entityShiftId?: string,
    options?: GetListFormatEntityShiftsAllocationsOptions
  ): Promise<EntityShiftAllocation[]> {
    const includePreviousDayStartedShifts = options?.includePreviousDayStartedShifts ?? true;
    let url = `/entities/${entityId}/shifts-allocations?startDate=${startDate}&endDate=${endDate}&tableFormat=false&includePreviousDayStartedShifts=${includePreviousDayStartedShifts}`;

    if (entityShiftId) {
      url += `&entityShiftId=${entityShiftId}`;
    }

    const response = await BackendApiManager.instance.get<EntityShiftAllocation[]>(
      url,
      options?.config
    );
    return response.data;
  }

  public async updateEntityShiftAllocation(
    entityId: string,
    userId: string,
    day: string,
    entityShiftId: string
  ): Promise<Pick<EntityShiftAllocation, 'entityShiftId'>> {
    const response = await BackendApiManager.instance.put<
      Pick<EntityShiftAllocation, 'entityShiftId'>
    >(`/entities/${entityId}/users/${userId}/shifts-allocations/${day}`, {entityShiftId});

    return response.data;
  }

  public async removeEntityShiftAllocation(
    entityId: string,
    userId: string,
    day: string,
    entityShiftId: string
  ): Promise<void> {
    await BackendApiManager.instance.delete(
      `/entities/${entityId}/users/${userId}/shifts-allocations/${day}?entityShiftId=${entityShiftId}`
    );
  }
}

export type GetListFormatEntityShiftsAllocationsOptions = {
  includePreviousDayStartedShifts?: boolean;
  config?: AxiosRequestConfig;
};
